// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Column from '../../components/Column';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import LoginLayout, { S as LoginLayoutStyle} from '../../layouts/LoginLayout';

const S = {
  LoginLayout: styled(LoginLayout)`
    ${LoginLayoutStyle.Card} {
      position: relative;
    }
  `,
  ForgetPasswordFormContainer: styled.div`
    margin-top: 38px;
    height: 100%;
  `,
  Wait30Description: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #FE4747;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
  `,
  Logo: styled.img`
    height: 16px;
    width: 115px;
  `,
  Container: styled(Column)`
    height: 100%;
    width: 100%;
    padding-top: 49px;
  `,
  HeaderContainer: styled(Column)`
    align-items: center;
  `,
  Title: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    margin-top: 15px;
    margin-bottom: 9px;
  `,
  SubTitle: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #666666;
    max-width:272px;
    text-align: center;
  `,
  GoToLoginPage: styled(Link)`
    display: flex;
    align-items: center;
    position: absolute;
    top: 24px;
    left: 30px;
    font-size: 16px;
    line-height: 23px;
    color: #EF8200;
  `,
  BackArrow: styled.img`
    width: 13px;
    margin-right: 3px;
    transform: rotate(-90deg);
  `,
  ConfirmWrapper: styled(Column)`
    width: 100%;
    margin-top: -25px;
    margin-bottom: 0px;
    position: relative;
    justify-content: space-between;
    align-items: center;
  `,
  ConfirmImg: styled.img`
    width: 220px;
    height: 220px;
  `,
  ConfirmLoginButton: styled(Button)`
    min-width: 112px;
    padding: 9px 20px;
    height: 44px;
    background: #FFFFFF;
    border: 1px solid #C9C9C9;
    border-radius: 4px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #EF8200;
    box-shadow: revert;

    &:hover {
      color: white;
      border: none;
    }
  `,
  ConfirmRetryButton: styled(Button)`
    min-width: 112px;
    padding: 9px 20px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    box-shadow: revert;
    margin-left: 20px;
  `,
  ConfirmTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  ConfirmDescription: styled.div`
    font-size: 16px;
    line-height: 23px;
    max-width: 233px;
    color: #666666;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
  `,
  ConfirmDescriptionWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
  `,
  ConfirmButtonWrapper: styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* width: 244px; */
  `
};

export { S as default }
